import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LiveAnalysisPage = lazy(() => import('../pages/live-analysis/page'));
const RankingsPage = lazy(() => import('../pages/rankings/page'));
const TokenAccessPage = lazy(() => import('../pages/token-access/page'));
const TokenAccessTeaserPage = lazy(() => import('../pages/token-access-teaser/page'));
const AlertsPage = lazy(() => import('../pages/alerts/page'));
const APIAccessPage = lazy(() => import('../pages/api-access/page'));
const BacktestingPage = lazy(() => import('../pages/backtesting/page'));
const MobileAppPage = lazy(() => import('../pages/mobile-app/page'));
const DisclaimerPage = lazy(() => import('../pages/disclaimer/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const BetaVideoPage = lazy(() => import('../pages/beta-video/page'));
const DemoDashboardPage = lazy(() => import('../pages/demo-dashboard/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/live-analysis',
    element: <LiveAnalysisPage />,
  },
  {
    path: '/rankings',
    element: <RankingsPage />,
  },
  {
    path: '/token-access',
    element: <TokenAccessPage />,
  },
  {
    path: '/token-access-teaser',
    element: <TokenAccessTeaserPage />,
  },
  {
    path: '/alerts',
    element: <AlertsPage />,
  },
  {
    path: '/api-access',
    element: <APIAccessPage />,
  },
  {
    path: '/backtesting',
    element: <BacktestingPage />,
  },
  {
    path: '/mobile-app',
    element: <MobileAppPage />,
  },
  {
    path: '/demo-dashboard',
    element: <DemoDashboardPage />,
  },
  {
    path: '/disclaimer',
    element: <DisclaimerPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/beta-video',
    element: <BetaVideoPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
